"use client";

import React, { useContext } from "react";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import SearchContext from "@/context/SearchContext";
import { useNavigation } from "@/hooks/useNavigation";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

import styles from "./QuizCTA.module.scss";

interface QuizCTAProps {
  isMobile?: boolean;
  isBottom?: boolean;
}

/**
 * Renders the sticky quiz CTA if quiz has not been taken.
 */
const QuizCTA: React.FC<QuizCTAProps> = ({ isMobile = false, isBottom = false }) => {
  const { searchState, search } = useContext(SearchContext);
  const navigate = useNavigation();

  // Check quiz data safely (only client-side)
  const quizData = typeof window !== "undefined" ? localStorage.getItem("quizResultsInfo") : null;

  if (quizData) {
    return null;
  }

  return (
    <div
      className={cn(
        styles.quizCtaWrapper,
        isMobile ? "md:hidden" : "hidden md:block",
        !isBottom && "scroll-shadow"
      )}
    >
      <ButtonNova
        level="Secondary"
        label="Take the Quiz for a Personalized Regimen"
        icon="Right"
        width="100%"
        onClick={() => {
          GA4.onSearchClicked({
            search_term: search,
            name: "Search",
            location: "navigation",
            state: searchState,
            text: "Take the Quiz for a Personalized Regimen",
            type: "Link",
            destination: "/hair/brand/quiz/",
          });
          navigate("/hair/brand/quiz/");
        }}
        className="mt-6 w-full max-w-[800px] mb-4"
      />
    </div>
  );
};

export default QuizCTA;
